export default async function getBlogs(id) {
  let Url;
  if (id) {
    Url = `${process.env.NEXT_PUBLIC_API_URL}/Blogs/blogs/${id}`;
  } else {
    Url = `${process.env.NEXT_PUBLIC_API_URL}/Blogs/blogs/`;
  }
  const result = await fetch(Url, { cache: "no-store" });
  return result.json();
}

// get blogs
